import { Form } from 'antd';

export default Form;



// WEBPACK FOOTER //
// ./src/components/uielements/form.js